var map = {
	"./Armorite.png": 43909,
	"./Armorite1.png": 49069,
	"./Armorite2.png": 92408,
	"./Armorite3.png": 26856,
	"./dynasty1.png": 84132,
	"./dynasty2.png": 89041,
	"./dynasty3.png": 53310,
	"./dynasty4.png": 36128,
	"./dynasty5.png": 43890,
	"./dynasty_overlay.png": 47057,
	"./lineback.png": 32331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50293;